"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var BulletChart = /** @class */ (function (_super) {
    __extends(BulletChart, _super);
    function BulletChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cachedMax = 0;
        return _this;
    }
    BulletChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_gravity":
                return { left: __1.Gravity.Left, right: __1.Gravity.Right }[value];
            case "_rangeFunc":
            case "_measuresFunc":
            case "_markersFunc":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    BulletChart.prototype.defaultOptions = function () {
        return {
            _gravity: __1.Gravity.Left,
            _rangesFunc: function (d) { return d.ranges; },
            _measuresFunc: function (d) { return d.measures; },
            _markersFunc: function (d) { return d.markers; },
            _titleFunc: function (d) { return d.title; },
            _subTitleFunc: function (d) { return d.subTitle; },
        };
    };
    BulletChart.prototype.init = function () {
        var _this = this;
        this.scale = d3.scaleLinear();
        this._ranges = this.appendGroupT(element_1.Rect).data([]).options({
            _x: function (d) { return _this.scale(d[0]); },
            _y: 0,
            _width: function (d) { return _this.scale(d[1]) - _this.scale(d[0]); },
            _height: "100%",
        });
        this._measures = this.appendGroupT(element_1.Rect).data([]).options({
            _x: function (d) { return _this.scale(d[0]); },
            _y: "25%",
            _width: function (d) { return _this.scale(d[1]) - _this.scale(d[0]); },
            _height: "50%",
        });
        this._markers = this.appendGroupT(element_1.Line).options({
            x1: this.scale,
            x2: this.scale,
            y1: 0, y2: "100%",
            stroke: "#fff",
        });
    };
    BulletChart.prototype.prepare = function () {
        var _this = this;
        this._processData();
        var gravity = this.getOption("_gravity");
        var anchor = (gravity === __1.Gravity.Right ? 64 /* Right */ : 16 /* Left */) | 2 /* Top */;
        this._ranges.options("_anchor", anchor);
        this._measures.options("_anchor", anchor);
        var width = this._getGeometry("_width", true);
        this.scale.domain([0, this._cachedMax]);
        this.scale.range(gravity === __1.Gravity.Right ? [width, 0] : [0, width]);
        this.setupProxy({
            ranges: "_ranges",
            measures: "_measures",
            markers: "_markers",
            axis: function (axis) {
                axis.options({
                    _scale: _this.scale,
                    _y: axis.getOption("_gravity") === __1.Gravity.Top ? 0 : "100%",
                });
            },
        });
    };
    BulletChart.prototype._processData = function () {
        var _this = this;
        var def = [["_rangesFunc", this._ranges], ["_measuresFunc", this._measures]];
        def.forEach(function (_a) {
            var key = _a[0], el = _a[1];
            var data = _this.getOption(key)(_this.datum);
            var last;
            if ((last = data[data.length - 1]) > _this._cachedMax) {
                _this._cachedMax = last;
            }
            // [1, 2, 3] => ([0, 1, 2] zip [1, 2, 3])
            el.data(_.zip([0].concat(data.slice(0, -1)), data));
        });
        this._markers.data(this.getOption("_markersFunc")(this.datum));
    };
    return BulletChart;
}(_1.Component));
exports.BulletChart = BulletChart;
//# sourceMappingURL=bullet-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/bullet-chart.js
// module id = 1150
// module chunks = 0 1